import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchReservations } from '@/lib/venue/reservationApi'
import type { ReservationListFilter } from '@/lib/venue/reservationViewModel'

export function reservationsQueryKey(venueId: string, filter: ReservationListFilter) {
  return ['venue', venueId, 'reservations', filter] as const
}

/**
 * 🚨 기존 `lib/api/cursor.ts`(`nextCursorFrom`) 패턴과 다르다 — 그쪽은 "커서를 직전 페이지
 * 마지막 원소의 필드로 클라이언트가 만든다"는 전제지만, 이 EP(#666 §3)는 서버가 `nextCursor` 를
 * 이미 인코딩된 불투명 문자열로 응답에 직접 내려준다. 그래서 `getNextPageParam` 을 직접 선언한다
 * (설계 §2-3(b)).
 */
export function useVenueReservations(venueId: string, filter: ReservationListFilter) {
  return useInfiniteQuery({
    queryKey: reservationsQueryKey(venueId, filter),
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchReservations(venueId, filter, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextExist ? (lastPage.nextCursor ?? undefined) : undefined),
  })
}
